export const GET_SALES_REQUEST = 'getSalesRequest';
export const GET_SALES_SUCCESS = 'getSalesSuccess';
export const GET_SALES_FAILURE = 'getSalesFailure';
export const SALES_NEXT_PAGE_SUCCESS = 'salesNextPageSuccess';
export const GET_BALANCE_REQUEST = 'getBalanceRequest';
export const GET_BALANCE_SUCCESS = 'getBalanceSuccess';
export const GET_BALANCE_FAILURE = 'getBalanceFailure';
export const PUT_BALANCE_REQUEST = 'putBalanceRequest';
export const PUT_BALANCE_SUCCESS = 'putBalanceSuccess';
export const PUT_BALANCE_FAILURE = 'putBalanceFailure';
export const BALANCE_NEXT_PAGE_SUCCESS = 'balanceNextPageSuccess';
// deprecated under tipster_progressive_fees feature flag.
export const PUT_PAYOUTS_METHOD_REQUEST = 'putPayoutsMethodRequest';
// deprecated under tipster_progressive_fees feature flag.
export const PUT_PAYOUTS_METHOD_SUCCESS = 'putPayoutsMethodSuccess';
// deprecated under tipster_progressive_fees feature flag.
export const PUT_PAYOUTS_METHOD_FAILURE = 'putPayoutsMethodFailure';

export const GET_STATS_REQUEST = 'getStatsRequest';
export const GET_STATS_SUCCESS = 'getStatsSuccess';
export const GET_STATS_FAILURE = 'getStatsFailure';

export const DOWNLOAD_ALL_CSV_SUCCESS = 'downloadAllCsvSuccessAction';
export const DOWNLOAD_ALL_CSV_FAILURE = 'downloadAllCsvFailureAction';
export const DOWNLOAD_ALL_CSV_REQUEST = 'downloadAllCsvRequestAction';

export const TIPSTER_FEE_TIERS_REQUEST = 'tipsterFeeTiersRequest';
export const TIPSTER_FEE_TIERS_FAILURE = 'tipsterFeeTiersFailure';
export const TIPSTER_FEE_TIERS_SUCCESS = 'tipsterFeeTiersSuccess';

export const UPDATE_BALANCE_OPTIMISTIC = 'updateBalanceOptimistic';
export const ADD_TRANSACTION_OPTIMISTIC = 'addTransactionOptimistic';
export const REMOVE_TRANSACTION_OPTIMISTIC = 'removeTransactionOptimistic';
